import fetch from "auth/FetchInterceptor";

const phlebotomyService = {};

phlebotomyService.fetch = function (params) {
  // console.log(params);
  // console.log("--->service");
  return fetch({
    url: "/specimen-tracking/phlebotomy-get",
    method: "post",
    data: params,
  });
};

phlebotomyService.drawHistory = function (sampleId) {
  return fetch({
    url: "/specimen-tracking/phlebotomy-draw-history?sample_id=" + sampleId,
    method: "get",
  });
};

phlebotomyService.addTube = function (data) {
  return fetch({
    url: "/specimen-tracking/phlebotomy-add-tube",
    method: "post",
    data,
  });
};

phlebotomyService.update = function (data) {
  return fetch({
    url: "/specimen-tracking/phlebotomy-update",
    method: "post",
    data,
  });
};

export default phlebotomyService;
